"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(_ref) {
  var theme = _ref.theme,
      hasBackground = _ref.hasBackground,
      isSubMenuItem = _ref.isSubMenuItem;
  return /*#__PURE__*/(0, _react.css)("font-size:inherit;font-weight:", isSubMenuItem ? theme.fontWeight.normal : theme.fontWeight.medium, ";color:inherit;padding:", theme.spacing[4], " ", theme.spacing[5], ";padding-left:", isSubMenuItem ? theme.spacing[7] : theme.spacing[5], ";display:flex;align-items:center;width:100%;border-radius:6px;text-decoration:none;&>*{opacity:0.7;transition:opacity 0.2s;}svg{width:", theme.spacing[10], ";height:", theme.spacing[10], ";vertical-align:middle;margin-right:3px;flex-shrink:0;}&:hover{background-color:", theme.color.monochrome.dark, ";}&.active{background-color:transparent;}&:hover,&.active{&>*{opacity:1;}.count{background-color:", theme.color.monochrome.white, ";color:", theme.color.monochrome.black, ";span{opacity:1;}}}", hasBackground && /*#__PURE__*/(0, _react.css)("background-color:rgba(\n      ", theme.color.monochrome.mediumDark_rgba, ",\n      0.44\n    )!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:base;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var count = function count(theme) {
  return /*#__PURE__*/(0, _react.css)("flex-shrink:0;padding:", theme.spacing[2], " ", theme.spacing[5], ";min-width:", theme.spacing[12], ";background-color:", theme.color.monochrome.dark, ";border-radius:", theme.spacing[6], ";color:inherit;opacity:1;transition:background-color 0.2s;font-weight:", theme.fontWeight.normal, ";&:empty{visibility:hidden;}span{opacity:0.7;transition:opacity 0.2s;}" + (process.env.NODE_ENV === "production" ? "" : ";label:count;"));
};

var arrow = function arrow(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", theme.spacing[11], "!important;height:", theme.spacing[11], "!important;transform:translateY(1px);margin-left:1px;transition:transform 0.2s;" + (process.env.NODE_ENV === "production" ? "" : ";label:arrow;"));
};

var openedArrow = process.env.NODE_ENV === "production" ? {
  name: "1qife6r",
  styles: "transform:translateY(1px) rotate(90deg)"
} : {
  name: "1mxfkwu-openedArrow",
  styles: "transform:translateY(1px) rotate(90deg);label:openedArrow;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var submenu = /*#__PURE__*/(0, _react.css)("padding-left:", (0, _util.rem)(26), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:submenu;"));
var styles = {
  base: base,
  count: count,
  arrow: arrow,
  openedArrow: openedArrow,
  submenu: submenu
};
exports.styles = styles;
//# sourceMappingURL=MenuItem.styles.js.map